module.exports = __webpack_public_path__ + "static/media/logo01-stack.9ca222a0.png";